"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Button = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.Button = styled_components_1.default.button `
  appearance: none;
  background: ${({ isActive, theme }) => isActive ? theme.ui01 : 'transparent'};
  color: ${({ theme }) => theme.textColor01};
  border-radius: 6px;
  outline: none;
  cursor: pointer;

  padding: ${({ subItem }) => (subItem ? '8px 14px' : '0')};
  width: 100%;
  transition: 150ms all;

  ${({ theme }) => theme.body01};
  ${({ isActive, theme }) => isActive && theme.bodyBold01}
  text-align: left;
  overflow-wrap: break-word;

  &:hover {
    background: ${({ isActive, theme }) => isActive ? theme.ui01 : theme.ui02};
  }

  border: 2px solid transparent;
  &:focus-visible {
    border-color: ${({ theme }) => theme.focus01};
  }

  display: flex;
  align-items: center;
  justify-items: flex-start;
  gap: 2px;
`;
